import React from 'react';

export default function RequiredMark() {
    return <span style={{ color: 'red', fontSize: '18px' }}>*</span>;
}
